import styled, { css } from "styled-components";

export const Container = styled.div`
  margin-top: 1rem;

  @media (min-width: 1600px) {
    margin-top: 2rem;
  }
`;

export const Label = styled.label`
  ${({ theme, error }) => css`
    width: 100%;
    height: 100%;
    border: none;
    pointer-events: none;
    font-size: ${theme.font.sizes.small};
    color: ${error ? "#c7170a" : theme.colors.gray};
    margin-bottom: 0.6rem;
    display: block;

    span {
      /* text-transform: uppercase; */
      font-size: 1.5rem;
      font-family: "Roboto";
      font-weight: 500;
    }

    @media (min-width: 1600px) {
      span {
        font-size: 2rem;
      }
    }
  `}
`;
export const TextArea = styled.textarea`
  ${({ theme, error }) => css`
    max-width: 100%;
    min-width: 100%;
    min-height: 9rem;
    font-family: "Roboto";
    border: solid 1px #b9b9ba;
    padding: 0.5rem;
    font-size: 1.6rem;
    resize: none;
    background: transparent;
  `}
`;
